import { Robot, Lightning, Envelope, ListChecks } from '@phosphor-icons/react';

const SUGGESTIONS = [
  { icon: ListChecks, text: "What's due this week?", color: 'text-[#f59e0b]', bg: 'bg-[#fef3c7]' },
  { icon: Lightning, text: "How much am I spending monthly?", color: 'text-[#7c3aed]', bg: 'bg-[#ede9fe]' },
  { icon: Envelope, text: "Any emails about my insurance?", color: 'text-[#0ea5e9]', bg: 'bg-[#e0f2fe]' },
  { icon: Robot, text: "Give me a quick status update", color: 'text-[#10b981]', bg: 'bg-[#d1fae5]' },
];

export const EmptyState = ({ onSuggestionClick }) => (
  <div className="flex-1 flex flex-col items-center justify-center p-6 text-center" data-testid="chat-empty-state">
    <div className="w-14 h-14 rounded-2xl bg-[#0f172a] flex items-center justify-center mb-4">
      <Robot size={28} className="text-white" weight="duotone" />
    </div>
    <h2 className="text-xl font-bold text-[#2d3338] mb-1">Hey, what's up?</h2>
    <p className="text-sm text-[#596065] mb-8 max-w-sm">
      I know your tasks, bills, and emails. Ask me anything.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-md">
      {SUGGESTIONS.map((s, i) => (
        <button
          key={i}
          onClick={() => onSuggestionClick(s.text)}
          className="flex items-center gap-3 text-left p-3 rounded-xl border border-[#f2f4f6] hover:border-[#e2e8f0] hover:shadow-sm transition-all bg-white"
          data-testid={`suggestion-${i}`}
        >
          <div className={`w-8 h-8 rounded-lg ${s.bg} ${s.color} flex items-center justify-center flex-shrink-0`}>
            <s.icon size={16} weight="duotone" />
          </div>
          <span className="text-xs text-[#596065]">{s.text}</span>
        </button>
      ))}
    </div>
  </div>
);
